// extracted by mini-css-extract-plugin
export default {"Header":"footer_Header__KDW5q","Container":"footer_Container__qvJjr","HeadRow":"footer_HeadRow__gK0we","HeadLogo":"footer_HeadLogo__riquy"};